export const SIMULATION_TOOL_PATH = '/simulation-tool';
export const CRITERIA_PATH = '/criteria';
export const PARAMETER_PATH = '/parameter';
export const NOTE_PATH = '/note';

export const SIMULATION_TOOL_TITLE = 'title.simulationTool';
export const CRITERIA_TITLE = 'title.criteriaSetting';
export const PARAMETER_TITLE = 'title.parameterSetting';
export const NOTE_TITLE = 'title.noteSetting';

export const CRITERIA_NAMESPACE = 'SIMULATION-CRITERIA';
export const PARAMETER_NAMESPACE = 'SIMULATION-PARAMETER';
export const NOTE_NAMESPACE = 'SIMULATION-NOTE';

export enum AdminSimulationToolPermissionType {
  CRITERIA_READ = 'READ_ANY_SIMULATION-CRITERIA',
  CRITERIA_CREATE = 'CREATE_ANY_SIMULATION-CRITERIA',
  CRITERIA_UPDATE = 'UPDATE_ANY_SIMULATION-CRITERIA',

  PARAMETER_READ = 'READ_ANY_SIMULATION-PARAMETER',
  PARAMETER_CREATE = 'CREATE_ANY_SIMULATION-PARAMETER',
  PARAMETER_UPDATE = 'UPDATE_ANY_SIMULATION-PARAMETER',

  NOTE_READ = 'READ_ANY_SIMULATION-NOTE',
  NOTE_CREATE = 'CREATE_ANY_SIMULATION-NOTE',
  NOTE_UPDATE = 'UPDATE_ANY_SIMULATION-NOTE',
}
